/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmacoPacienteDto } from '../../models/farmaco-paciente-dto';

export interface FarmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Params {
  farmacoUuid: string;
}

export function farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria(http: HttpClient, rootUrl: string, params: FarmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmacoPacienteDto>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria.PATH, 'get');
  if (params) {
    rb.path('farmacoUuid', params.farmacoUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FarmacoPacienteDto>;
    })
  );
}

farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria.PATH = '/api/farmacos/detalle-farmaco-farmacia-hospitalaria/{farmacoUuid}';
